import React from "react";
import AddRelocationDetailDesktopView from "../../AddRelocationDetails/DesktopView/AddRelocationDetailDesktopView";
import AddCustomerDetailsDesktopView from "../../AddCustomerDetails/DesktopView/AddCustomerDetailsDesktopView";
import AddPetDetailsDesktopView from "../../AddPetDetails/DesktopView/AddPetDetailsDesktopView";
import "./BookingFormPreviewDesktopView.css";
import { useEffect,useState } from "react";

function BookingFormPreviewDesktopView({ activeForm, setActiveForm }) {
  const OpenDocumentForm = () => {
    setActiveForm({
      customerDetails: false,
      relocationDetails: false,
      petDetails: false,
      preview: false,
      documentation: true,
    });
  };

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked); // Update checkbox state
  };

  return (
    // <div style={{backgroundColor:"white",borderRadius:"8px",boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px"}} className='mb-4'>
    <div className="mb-4">
      <AddCustomerDetailsDesktopView preview={true} />
      <AddRelocationDetailDesktopView preview={true} />
      <AddPetDetailsDesktopView preview={true} />
      <div className="main p-0">
        <div className="container px-3">
          <div
            style={{ backgroundColor: "white", borderRadius: "8px" }}
            className="container p-0 mt-4 d-flex justify-content-center align-items-baseline"
          >
            <input style={{ marginLeft: "17px" }} type="checkbox" onChange={handleCheckboxChange}/>
            <p
              style={{ fontSize: "16px", lineHeight: "23px", padding: "14px" }}
            >
              I hereby declare that I have thoroughly reviewed the above details
              and have filled in all the required information. I am ready to
              proceed with the further documentation and execution process for
              the pet transportation.
            </p>
          </div>
        </div>
      </div>

      <hr style={{ marginTop: "46px" }} />
      <div
        style={{ textAlign: "end" }}
        className="form-button-div mt-3 px-4 mb-4"
      >
        <button
          onClick={OpenDocumentForm}
          style={{ width: "196px", fontSize: "16px", backgroundColor: "white" }}
          type="submit"
          className="btn mb-4"
          disabled={!isChecked}
        >
          SAVE & NEXT <span style={{ fontSize: "20px" }}>&rarr;</span>
        </button>
      </div>
    </div>
  );
}

export default BookingFormPreviewDesktopView;
